import type { DeliverableCheck, DeliverableCheckStatus } from '@/types/portal';

const STATUS_STYLE: Record<DeliverableCheckStatus, { icon: string; wrap: string }> = {
  pass: { icon: 'ri-check-line', wrap: 'bg-accent-100 text-accent-700' },
  warn: { icon: 'ri-error-warning-line', wrap: 'bg-secondary-100 text-secondary-700' },
  fail: { icon: 'ri-close-line', wrap: 'bg-primary-100 text-primary-700' },
};

export default function DeliverableChecks({ checks }: { checks: DeliverableCheck[] }) {
  return (
    <ul className="space-y-2">
      {checks.map((check) => {
        const style = STATUS_STYLE[check.status];
        return (
          <li key={check.id} className="flex items-start gap-2.5">
            <span
              className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-sm ${style.wrap}`}
            >
              <i className={style.icon} />
            </span>
            <div className="min-w-0">
              <p className="text-sm font-medium text-foreground-800">{check.label}</p>
              <p className="text-xs leading-relaxed text-foreground-500">{check.detail}</p>
            </div>
          </li>
        );
      })}
    </ul>
  );
}